import React, { useState, Fragment } from "react"
import styled from "styled-components"
import globals from "../globals"
import { H2, H4 } from "../headings/index"
import Container from "../container/index"
import {
  InternalHeader,
  FaqImageWrapper,
  FaqTitleWrapper,
  ArrowWrapper,
  FaqItemWrapper,
  FaqItem as FaqItemCopy,
} from "./style"
import { Tabs, Tab } from "../tabs/index"
import Video from "../video/index"
import IllustraFaq from "../../images/picto-faq.svg"
import { ReactComponent as Arrow } from "../../images/arrow.svg"

const FAQ = styled.dl`
  width: 100%;
  max-width: 720px;
  display: block;
  margin: 0 auto 60px;
  text-align: center;

  button {
    background: none;
    border: none;
    padding: 0 10px;
    margin: 0;
    width: 100%;
    display: block;
    transition: color 0.1s ease;
    cursor: pointer;
    color: ${globals.colors.darkblue};

    &:active,
    &:focus {
      outline: none;
    }
  }

  dt {
    padding: 20px 0;

    h4 {
      margin: 0;
      padding: 0;
    }
  }

  dd {
    line-height: 1.6;
    padding: 0 10px;
  }
`

const FaqTitle = props => {
  const { onClick, index, currentQuestionIndex, question, isActive } = props

  return (
    <FaqTitleWrapper>
      <button
        onClick={onClick}
        aria-expanded={(currentQuestionIndex === index).toString()}
        aria-controls={`faq_desc_${index}`}
      >
        <H4 weight={isActive ? 800 : 400}>{question}</H4>
        <ArrowWrapper isActive={isActive}>
          <Arrow />
        </ArrowWrapper>
      </button>
    </FaqTitleWrapper>
  )
}

const FaqItem = props => {
  const { question, onClick, index, isActive, answer, video } = props
  const isComplexAnswer = typeof answer === "function"

  return (
    <FaqItemWrapper>
      <FaqTitle
        question={question}
        onClick={onClick}
        isActive={isActive}
        index={index}
      />
      <FaqItemCopy style={{ maxHeight: isActive ? "99999px" : "0px" }}>
        {video && (
          <Video
            style={{ marginBottom: answer ? "20px" : 0 }}
            youtubeId={video}
          />
        )}
        <p id={`faq_desc_${index}`} className="desc">
          {isComplexAnswer ? answer() : answer}
        </p>
      </FaqItemCopy>
    </FaqItemWrapper>
  )
}

const Faq = props => {
  const [questionIndex, setQuestionIndex] = useState(null)

  const faqServico = [
    {
      question: "A CredPago se tornou uma seguradora?",
      answer:
        "Não. O seguro residencial que é oferecido na plataforma da CredPago é um produto distribuído pela 180 Seguros em parceria com a CredPago.",
    },
    {
      question: "O que é o Seguro Residencial da CredPago?",
      answer:
        "O seguro residencial da CredPago é um produto emitido pela 180 Seguros em parceria com a CredPago para levar mais segurança aos imóveis alugados pelo menor preço do mercado. Com esse seguro, o imóvel está protegido de acordo com a cobertura escolhida no momento da contratação.",
    },
    {
      question:
        "O Seguro Residencial da CredPago tem custo para a imobiliária?",
      answer: "Não. O seguro residencial não tem custo para as imobiliárias.",
    },
    {
      question:
        "Para qual tipo de imóvel o Seguro Residencial pode ser contratado?",
      answer:
        "Como o próprio nome do produto sugere, o Seguro Residencial da CredPago é exclusivamente para imóveis residenciais, não podendo então ser contratado para imóveis que tenham finalidade comercial.",
    },
    {
      question:
        "O Seguro Residencial da CredPago é obrigatório nos contratos de locação?",
      answer:
        "Não. O Seguro Residencial da CredPago oferece cobertura contra incêndio, que é obrigatória por lei. No entanto, o inquilino pode optar por contratar esse seguro incêndio em outra empresa, se assim preferir.",
    },
    {
      question:
        "Qual a vantagem da imobiliária em utilizar o Seguro Residencial da CredPago?",
      answer:
        "A CredPago oferece maior simplicidade e agilidade na hora da contratação do seguro residencial. Com poucos cliques, você deixa o imóvel segurado contra danos, de acordo com a cobertura escolhida. Você também poderá contratar o seguro residencial para imóveis que não contam com a fiança CredPago.",
    },
    {
      question:
        "Qual a vantagem do inquilino em utilizar o Seguro Residencial da CredPago?",
      answer:
        "A principal vantagem do seguro residencial da CredPago é flexibilidade na escolha das assistências para deixar o imóvel protegido contra raio, incêndio, explosão, danos elétricos, vendaval, perda de aluguel e responsabilidade civil.",
    },
    {
      question:
        "Qual é o preço/taxa ou tabela de custos do Seguro Residencial da CredPago?",
      answer:
        "Não há um valor fixo para o Seguro Residencial da CredPago. Para saber os valores, a imobiliária deverá acessar o sistema da CredPago e fazer uma simulação para informar os valores ao cliente.",
    },
    {
      question: "Quais as condições de pagamento para o Seguro Residencial?",
      answer:
        "O inquilino poderá pagar o seguro residencial em até 12X no cartão de crédito, conforme o mesmo ocorre na contratação da garantia locatícia da CredPago. Também aceitamos pagamento via boleto e Pix.",
    },
    {
      question:
        "Há comissão para as imobiliárias sobre o Seguro Residencial CredPago?",
      answer:
        "Para mais informações sobre comissão, consulte o executivo de negócios da CredPago na sua região.",
    },
    {
      question:
        "Sobre a 180º Seguros",
      answer:
        "A 180 Seguros é a Seguradora responsável pela proteção do seu seguro residencial. Todo contato será feito com a seguradora, seja para acionar uma das suas proteções ou assistência para sua residência. A 180 atualmente conta com grandes empresas no portfólio de clientes.",
    },
  ]

  const answerPlanos = () => (
    <div>
      <ul>
        <li>Incêndio, Raio, Explosão, Fumaça e Queda de Aeronaves</li>
        <li>Danos Elétricos</li>
        <li>Vendaval, Furacão, Ciclone, Tornado e Granizo</li>
        <li>Responsabilidade Civil Familiar</li>
        <li>Perda ou Pagamento de Aluguel</li>
      </ul>
    </div>
  )

  const answerAssistencias = () => (
    <div>
      <p>
        <strong>Assistência Emergencial Essencial:</strong> Eletricista, Encanador, Chaveiro, Vidraceiro, Indicação de mão de obra, Vigilância, Cobertura provisória de telhados e Desentupimento de tubulações.
      </p>
      <p>
        <strong>Assistência Emergencial Completo:</strong> Eletricista, Encanador, Chaveiro, Vidraceiro, Indicação de mão de obra, Vigilância, Cobertura provisória de telhados, Desentupimento de tubulações, Dedetização, Substituição de telhas, Limpeza de ar condicionado, Limpeza de caixa d'água e Limpeza de residência.
      </p>
      <p>
        <strong>Assistência Emergencial Completo + PET:</strong> Eletricista, Encanador, Chaveiro, Vidraceiro, Indicação de mão de obra, Vigilância, Cobertura provisória de telhados, Desentupimento de tubulações, Dedetização, Substituição de telhas, Limpeza de ar condicionado, Limpeza de caixa d'água, Limpeza de residência, (PET)Assistência funeral, (PET)Transporte funerário, (PET)Consultas veterinárias e (PET)Aplicação de vacinas em domicílio (duas intervenções durante a vigência).
      </p>
    </div>
  )

  const faqContratacao = [
    {
      question: "Quais são as coberturas do Seguro Residencial CredPago?",
      answer: answerPlanos,
    },
    {
      question:
        "Que tipo de assistências posso acrescentar em minha cobertura?",
      answer: answerAssistencias,
    },
    {
      question: "Como contratar o Seguro Residencial com a CredPago?",
      answer:
        "Na hora de fazer uma solicitação de aluguel com a garantia da CredPago, a imobiliária poderá fazer a cotação e acrescentar o seguro residencial na qual já protege o imóvel contra incêndio, assim dispensando qualquer necessidade de contratação adicional ou ela poderá acessar a área de seguro e efetuar a contratação por lá.",
    },
    {
      question: "Quem pode contratar o Seguro Residencial da CredPago?",
      answer:
        "Todos os inquilinos que alugarem imóveis residenciais com os serviços da garantia locatícia da CredPago podem contratar o Seguro Residencial, que é ativado também na plataforma CredPago, e agora você que não possui garantia locatícia CredPago, poderá também utilizar do melhor seguro residencial do mercado.",
    },
    {
      question:
        "Em casos de sinistro, quais são as regras para acionamento do seguro?",
      answer:
        "Em caso de sinistro, a imobiliária e/ou cliente deverão entrar em contato com a 180 Seguros (0800 888 1018) para verificar as condições para acionamento do seguro.",
    },
    {
      question:
        "Qual a vigência e como ocorre a renovação do Seguro Residencial da CredPago?",
      answer:
        "Após a contratação, o Seguro Residencial da CredPago possui uma vigência de 12 meses. Ao fim desta vigência, a imobiliária deve criar uma nova cotação e, após o pagamento, uma nova apólice será gerada.",
    },
    {
      question:
        "Em caso de cancelamento, como o inquilino ou imobiliária devem preceder?",
      answer:
        "Em caso de cancelamento, a imobiliária pode solicitá-lo diretamente no plataforma da CredPago.",
    },
  ]

  return (
    <div id="faq">
      <Container>
        <InternalHeader>
          <H2>
            <span>FAQ - </span>Dúvidas Frequentes
          </H2>
          <p>
            Nesta página você pode tirar todas suas dúvidas sobre o Seguro
            Residencial CredPago. Caso você ainda tenha alguma dúvida que não
            está no FAQ, entre em contato pelo email{" "}
            <strong>comercial@credpago.com</strong> ou pelo telefone{" "}
            <strong>0800 001 6002</strong>
          </p>
          {/* <H5 weight={'normal'}>Lorem ipsum dolor sit amet consectetuer adipiscing elit</H5> */}
        </InternalHeader>

        <FaqImageWrapper>
          <img
            src={IllustraFaq}
            width="469"
            alt="Perguntas Frequentes Seguro Residencial"
          />
        </FaqImageWrapper>

        <Tabs afterTabChange={() => setQuestionIndex(null)}>
          <Tab label="Sobre o Serviço">
            <FAQ>
              {faqServico.map((item, index) => {
                return (
                  <Fragment key={index}>
                    <FaqItem
                      question={item.question}
                      onClick={() => setQuestionIndex(index)}
                      index={index}
                      isActive={questionIndex === index}
                      answer={item.answer}
                      video={item.video}
                    />
                  </Fragment>
                )
              })}
            </FAQ>
          </Tab>
          <Tab label="Sobre a Contratação">
            <FAQ>
              {faqContratacao.map((item, index) => {
                return (
                  <Fragment key={index}>
                    <FaqItem
                      question={item.question}
                      onClick={() => setQuestionIndex(index)}
                      index={index}
                      isActive={questionIndex === index}
                      answer={item.answer}
                      video={item.video}
                    />
                  </Fragment>
                )
              })}
            </FAQ>
          </Tab>
        </Tabs>
      </Container>
    </div>
  )
}
export default Faq
